import angular from "angular";
import "./api/user";

angular.module("folkeuni").factory("User", function (UserApi, $q) {
  var user = this,
    currentUser = null,
    currentUserPromise = null;

  user.exists = function (siteId, email) {
    var deferred = $q.defer();

    UserApi.exists(siteId, email).then(
      function (response) {
        deferred.resolve(response.data);
      },
      function (res) {
        deferred.reject(res);
      }
    );

    return deferred.promise;
  };

  user.validate = function (customerObj) {
    var deferred = $q.defer();

    UserApi.validate(customerObj).then(
      function (validationObj) {
        deferred.resolve(validationObj.data);
      },
      function (res) {
        deferred.reject(res);
      }
    );
    return deferred.promise;
  };

  user.activate = function (userObj) {
    var deferred = $q.defer();

    UserApi.activate(userObj).then(
      function (response) {
        deferred.resolve(response.data);
      },
      function (res) {
        deferred.reject(res);
      }
    );

    return deferred.promise;
  };

  user.cprUpdate = function (cpr) {
    var deferred = $q.defer();

    UserApi.cprUpdate(cpr).then(
      function (response) {
        deferred.resolve(response.data);
      },
      function (res) {
        deferred.reject(res);
      }
    );

    return deferred.promise;
  };

  user.create = function (userObj) {
    var deferred = $q.defer();

    UserApi.create(userObj).then(
      function (successResponse) {
        deferred.resolve(successResponse);
      },
      function (errorResponse) {
        deferred.reject(errorResponse);
      }
    );

    return deferred.promise;
  };

  user.getCurrent = function () {
    var deferred = $q.defer(),
      promise = currentUserPromise ? currentUserPromise : deferred.promise;

    if (currentUser !== null) {
      deferred.resolve(currentUser);
    } else {
      currentUserPromise = promise;

      UserApi.getCurrent().then(
        function (userObj) {
          currentUser = userObj.data;
          deferred.resolve(currentUser);
        },
        function (errorResponse) {
          deferred.reject(errorResponse);
        }
      );
    }
    return promise;
  };

  user.login = function (userObj) {
    var deferred = $q.defer();

    UserApi.login(userObj).then(
      function (loginStatus) {
        deferred.resolve(loginStatus.data);
      },
      function (res) {
        deferred.reject(res);
      }
    );

    return deferred.promise;
  };

  user.passwordForgot = function (emailObj) {
    var deferred = $q.defer();

    UserApi.passwordForgot(emailObj).then(
      function (updateObj) {
        deferred.resolve(updateObj.data);
      },
      function (errorResponse) {
        deferred.reject(errorResponse);
      }
    );

    return deferred.promise;
  };

  user.passwordReset = function (passwordObj) {
    var deferred = $q.defer();

    UserApi.passwordReset(passwordObj).then(
      function (updateObj) {
        deferred.resolve(updateObj.data);
      },
      function (errorResponse) {
        deferred.reject(errorResponse);
      }
    );

    return deferred.promise;
  };

  user.update = function (userObj) {
    var deferred = $q.defer();

    UserApi.update(userObj).then(
      function (updateObj) {
        deferred.resolve(updateObj.data);
      },
      function (errorResponse) {
        deferred.reject(errorResponse);
      }
    );

    return deferred.promise;
  };

  return user;
});
